import { CodeBlockPlugin, CodeLinePlugin } from '@udecode/plate-code-block/react'
import { getBlockAbove, getNodeString, isType, replaceNode, select } from '@udecode/plate-common'
import { createPlatePlugin, ParagraphPlugin } from '@udecode/plate-common/react'

/**
 * Handles Enter key to create code blocks when typing ```language
 * Triggers on: ```<Enter> or ```json<Enter>
 */
export const CodeBlockEnterPlugin = createPlatePlugin({
    key: 'codeBlockEnter',
    handlers: {
        onKeyDown: ({ editor, event }) => {
            if (event.key !== 'Enter') {
                return
            }

            const block = getBlockAbove(editor)
            if (!block) {
                return
            }

            const [node, path] = block

            // Only handle paragraphs
            if (!isType(editor, node, ParagraphPlugin.key)) {
                return
            }

            const text = getNodeString(node)

            // Match ``` or ```language (e.g., ```json, ```typescript)
            const match = text.match(/^```(\w*)$/)
            if (!match) {
                return
            }

            // Prevent default Enter behavior
            event.preventDefault()

            const lang = match[1] || undefined

            // Replace the paragraph with a code block
            replaceNode(editor, {
                at: path,
                nodes: {
                    type: CodeBlockPlugin.key,
                    lang,
                    children: [
                        {
                            type: CodeLinePlugin.key,
                            children: [{ text: '' }],
                        },
                    ],
                },
            })

            // Select inside the code line
            const codeLinePath = [...path, 0, 0]
            select(editor, { path: codeLinePath, offset: 0 })
        },
    },
})
